import { AppRouteProps } from '~/routes';
import CheckoutWarehouse from './pages/CheckoutWarehouse';
import Index from './pages/Index';
import CheckinWarehouse from './pages/CheckinWarehouse';

export default function ResourcesWarehouseCheckoutRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/warehouse-checkout',
      component: Index,
      isProtected: true,
      // permissions: ['warehouse_index'],
    },
    {
      path: '/warehouse-checkout/create',
      component: CheckoutWarehouse,
      isProtected: true,
      // permissions: ['warehouse_create'],
    },
    {
      path: '/warehouse-checkout/return/:id',
      component: CheckinWarehouse,
      isProtected: true,
      // permissions: ['warehouse_edit'],
    },
  ];

  return routes;
}
